import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { history } from 'helpers';

export { VerifiedRoute };

function VerifiedRoute({ children }) {
    const { user: authUser } = useSelector(x => x.auth);
    
    if (authUser.verified === "false") {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/verify" state={{ from: history.location }} />
    }

    // authorized so return child components
    return children;
}